import { InputImage } from "../file-classes";

const resize = async ({ maxWidth = 0, maxHeight = 0 }, file) => {
    const image = new InputImage(file);
    if ((maxWidth || maxHeight) && image.hasValidExtension()) {
        if (
            (await image.width()) > maxWidth ||
            (await image.height()) > maxHeight
        ) {
            const resized = await image.resize(
                maxWidth || maxHeight,
                maxHeight || maxWidth,
                "image/jpeg"
            );
            return resized;
        }
    }
    return file;
};

export { resize };
